import script from "./HomePageSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageSettings.vue?vue&type=script&setup=true&lang=js"

import "./HomePageSettings.vue?vue&type=style&index=0&id=d145eae4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d145eae4"]])

export default __exports__